import { StoreAction, XmAction } from 'store/actions';
import { NowBuyFlow } from './models/buy-flow';


export function nowBuyFlowReducer(state: NowBuyFlow, action: XmAction<NowBuyFlow>): NowBuyFlow {
    switch (action.type) {
        case StoreAction.POST_SALES_INTENT:
            return action.payload;
        default:
            return state;
    }
}
